import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  MAIN_URL,
  PORT,
  API_GET_ISSUING_CERTIFICATES_SEARCH,
  API_GET_ISSUING_CERTIFICATES_APPLICANT_SEARCH,
  API_GET_APPLICANT_INFO_BY_ID,
  API_GET_ISSUING_APP_BY_ID,
} from "../../constants/constants";
import {
  SET_SEARCH_PARAMS_ISSUING_CERTIFICATES,
  GET_DATA_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES,
  GET_DATA_APPLICANT_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES,
  ADD_NEW_DATA_ISSUING_CERTIFICATES,
  GET_APPLICANT_INFO_BY_ID,
  GET_ISSUING_APP_BY_ID,
  CLEAR_ISSUING_APP_DATA,
} from "../types";
import { setDefaultOptions } from "../../components/AdministrativeProcedures/issuingCertificatesAppRHF/optionsIssuingCertificatesAppRHF";

export function setSearchParams(key, value) {
  return {
    type: SET_SEARCH_PARAMS_ISSUING_CERTIFICATES,
    data: { [`${key}`]: value },
  };
}

export function getDataIssuingCertificatesBySearchParams(params, page) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL +
        PORT +
        API_GET_ISSUING_CERTIFICATES_SEARCH +
        "page=" +
        page +
        "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES,
        data: response,
      });
    }
  };
}

export function getDataApplicantBySearchParams(params, page) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL +
        PORT +
        API_GET_ISSUING_CERTIFICATES_APPLICANT_SEARCH +
        "page=" +
        page +
        "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      const responseValid = response.content.map((item) => {
        item.dateStartEnd =
          !!item.dateStart && !!item.dateEnd
            ? `${item.dateStart} - ${item.dateEnd}`
            : "";
        return item;
      });
      dispatch({
        type: GET_DATA_APPLICANT_BY_SEARCH_PARAMS_ISSUING_CERTIFICATES,
        data: { ...response, content: responseValid },
      });
    }
  };
}

export function addNewDataIssuingCertificates(object) {
  return {
    type: ADD_NEW_DATA_ISSUING_CERTIFICATES,
    data: object,
  };
}

export function getApplicantInfoById(id) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT + API_GET_APPLICANT_INFO_BY_ID + id,
    ).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      const applicantData = response.examCheckView;
      const validData = {
        ...applicantData,
        licenseType: applicantData.programId === 1 ? 1 : 2,
        licenseTypeName:
          applicantData.programId === 1 ? "Республиканское" : "Международное",
        theoreticalExam: response.theoreticalExam,
        practicalExam: response.practicalExam,
        trainingProgram: applicantData.programId,
        trainingBegin: applicantData.dateStart,
        trainingEnd: applicantData.dateEnd,
        trainingDocDepartment: applicantData.trainingOrgName,
        docSeries: applicantData?.docNum?.split(" ")[0],
        docNum: applicantData?.docNum?.split(" ")[1],
        validTypeId: response.dlValidTypeId,
        validZoneId: response.dlValidZoneId,
        validTypeName: response.validTypeName,
        validZoneName: response.validZoneName,
        statusId: 1,
        appTypeId: 1,
      };
      delete validData.section;
      if (response.boatDrivingLicense !== null) {
        validData.licenseNumExist = response.boatDrivingLicense.licenseNum;
        validData.licenseDateExist =
          response.boatDrivingLicense.licenseDate.slice(0, 10);
      }
      dispatch({
        type: GET_APPLICANT_INFO_BY_ID,
        data: validData,
      });
    }
  };
}

export function getIssuingAppDataById(id) {
  return async (dispatch) => {
    const request = await fetchWithToken(
      MAIN_URL + PORT + API_GET_ISSUING_APP_BY_ID + id,
    ).catch((err) => {
      console.log(err);
    });
    if (request.status === 200) {
      const response = await request.json();
      response.licenseTypeName =
        response.licenseType === 1 ? "Республиканское" : "Международное";
      if (response.licenseType === 2) {
        response.validTypeName = response.validTypeId?.name;
        response.validZoneName = response.validZoneId?.name;
      }
      response.trainingProtNum = `${response?.trainingProtNum}/2`;
      if (response.appFile) {
        response.appFileId = response.appFile.docid;
        response.viewFileName = response.appFile.docname;
      }
      response.medConditionsId = response?.medCondition;
      // response.docType = response.docTypeId;
      if (!!response.agent) {
        for (let item in response.agent) {
          response[item] = response.agent[item];
        }
      }
      // response.trainingDocType = !!response.trainingDocTypeId ? response.trainingDocTypeId : null;
      // response.inspector = response.appUser;
      dispatch({
        type: GET_ISSUING_APP_BY_ID,
        data: response,
      });
    }
  };
}

export function clearIssuingAppData() {
  return {
    type: CLEAR_ISSUING_APP_DATA,
    data: {},
  };
}
